var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgTtb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 141.7",
    style: {
      enableBackground: "new 0 0 141.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#0F50EC;}\n\t.st2{fill:#F48A31;}\n\t.st3{fill:#022D61;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 108.9,
    cy: 76.9,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.9,89.9c-7.2,0-13-5.8-13-13V64.4h12.5v-12H19.9V39.9h-12v12.5v12v12.5c0,13.8,11.2,25,25,25 c7.6,0,14.4-3.4,19-8.8c-3.7-4.4-6-10-6-16.2C45.9,84,40,89.9,32.9,89.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.9,76.9c0,7.2-5.8,13-13,13s-13-5.8-13-13V64.4h12.5v-12H57.9V39.9h-12v12.5v12v12.5c0,6.2,2.3,11.9,6,16.2 c4.6,5.4,11.4,8.8,19,8.8s14.4-3.4,19-8.8C86.1,88.7,83.9,83.1,83.9,76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.9,51.9c-4.8,0-9.2,1.3-13,3.6V39.9h-12v37c0,6.2,2.3,11.9,6,16.2c4.6,5.4,11.4,8.8,19,8.8 c13.8,0,25-11.2,25-25S122.7,51.9,108.9,51.9z M108.9,89.9c-7.2,0-13-5.8-13-13s5.8-13,13-13s13,5.8,13,13S116,89.9,108.9,89.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtb);
export default __webpack_public_path__ + "static/media/ttb.552c88cb.svg";
export { ForwardRef as ReactComponent };